export default __webpack_public_path__ + "static/media/room5.d754486a.jpg";